<template>
  <div>
    <a-card :bordered="false" title="账户管理">
      <a slot="extra" @click="handleHelp">
        <a-icon type="question-circle" />
      </a>
      <div class="account-container">
        <div class="spread">
          <lottie :options="animationData.property1" :height="100" :width="100"></lottie>
        </div>
        <div>
          <a-statistic title="可用余额 (NB)" :precision="2" :value="nb_credit/100" />
          <div class="btns">
            <a-button disabled class="item" type="primary" size="small" @click="$refs.purchaseModal.show()">充值</a-button>
            <a-button class="item" type="primary" size="small" @click="$refs.transferModal.show()">转赠</a-button>
            <a-button class="item" type="default" size="small" @click="$refs.billModal.show()">账单明细</a-button>
          </div>
        </div>
      </div>
    </a-card>
    <purchase-modal ref="purchaseModal" @ok="getData"></purchase-modal>
    <transfer-modal ref="transferModal" @ok="getData"></transfer-modal>
    <bill-modal ref="billModal"></bill-modal>
  </div>
</template>

<script>
import Lottie from '@/common/Lottie/lottie.vue'
import * as animationData1 from '@/assets/lottie/property@1.json'
import PurchaseModal from './PurchaseModal'
import TransferModal from './TransferModal'
import BillModal from './BillModal'
import { getInfo } from '@/api/login'
export default {
  components: {
    Lottie,
    PurchaseModal,
    TransferModal,
    BillModal
  },
  data() {
    return {
      animationData: {
        property1: { animationData: animationData1 }
      },
      nb_credit: 0
    }
  },
  computed: {},
  filters: {},
  created() {
    this.getData()
  },
  methods: {
    handleHelp() {
      this.$info({
        title: 'NB账户说明',
        content: (
          <div>
            <p>1.NB是系统内账户积分，可以在系统内自由流通。</p>
            <p>2.NB可以通过抽奖、系统活动、充值等方式获得。</p>
            <p>3.NB可以用于购买本系统生态内充值卡密等产品。</p>
          </div>
        )
      })
    },
    getData() {
      getInfo().then(res => {
        if (res.code === 1) {
          const nb_credit = res.data.operate_info.nb_credit
          this.nb_credit = nb_credit
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.account-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .btns {
    margin: 5px 0;
    .item {
      margin-right: 5px;
    }
  }
}
</style>
